import React, { useEffect, useState } from 'react'
import './SchoolPartnership.css'
import icon from '../../assetsS/images/fa-solid_school.png'

const Gallery = () => {
  useEffect(() => {})

  const specs = [
    'Assign unlimited test to any number of students just by 1 click',
    'Subject wise teacher admin login dashboard',
    'Answers , Explanations, Concept details',
    'Automatic test results in stunning dashboards',
    'Terminology Training',
    'Answering Speed & Accuracy Training',
    'OMR sheet upload and evaluation',
    'Customised Testing practice',
    "Capability analysis report: MCQ's answering speed of the students every 10 minutes in the exam is monitored",
    'Avg time taken by students chapter-wise, direct question and indirect twisted questions are measured',
    'AI based system formulated the customized test practice for students based on the capability analysis report',
  ]

  return (
    <div className="specsec">
      <div className="container">

        {/* ── Heading ── */}
        <div className="specsec__header">
          <p className="specsec__eyebrow">Specifications</p>
          <h2 className="specsec__headline">
            What are the specifications of{' '}
            <span className="specsec__accent">SARASU NEET</span> Online Testing
            Practice Software?
          </h2>
          <div className="specsec__divider" />
        </div>

        {/* ── Table ── */}
        <div className="row justify-content-center">
          <div className="col-12 col-xl-10">
            <div className="specsec__table-wrap">
              <table className="table table-bordered specsec__table normaltextblack1 bluebackcolor">
                <thead>
                  <tr>
                    <th className="specsec__th specsec__th--main tabalign" scope="col">
                      Specifications
                    </th>
                    <th className="specsec__th specsec__th--detail tabalign" scope="col">
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {specs.map((spec, i) => (
                    <tr key={i} className="specsec__row">
                      <th scope="row" className="specsec__row-label">{spec}</th>
                      <td className="specsec__row-value text-center">Yes</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Gallery